import {
  Box,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
} from '@mui/material';

import { ClassCodeTableCell } from 'src/components/ncrb-table-cells/class-code';

import { formatDate, formatDollarAmount } from '../../../../../shared/utils/policyUtils';

import type { USRExposuresTableSubRow } from '../types';

export default function UnitStatExposuresNestedTable({
  rows,
}: {
  rows: USRExposuresTableSubRow[];
}) {
  const cellBottomSx = { borderBottom: '1px dashed var(--palette-divider)' };

  return (
    <Box sx={{ py: 2 }}>
      <TableContainer sx={{ backgroundColor: 'background.paper', borderRadius: 2 }}>
        <Table aria-label="unit-stat-exposure-details">
          <TableHead>
            <TableRow>
              <TableCell>Mod type</TableCell>
              <TableCell>Update type</TableCell>
              <TableCell>Mod effective</TableCell>
              <TableCell>Rate effective</TableCell>
              <TableCell>Experience mod</TableCell>
              <TableCell>Class code</TableCell>
              <TableCell>Exposure</TableCell>
              <TableCell>Manual rate</TableCell>
              <TableCell>Premium</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((subRow, rowIndex) => (
              <TableRow
                sx={cellBottomSx}
                key={subRow.exposureId}
                data-testid={`exposure-sub-row-${subRow.exposureId}`}
              >
                <TableCell data-testid={`modType-${rowIndex}`}>{subRow.modType ?? ''}</TableCell>
                <TableCell data-testid={`updateType-${rowIndex}`}>
                  {subRow.updateType ?? ''}
                </TableCell>
                <TableCell data-testid={`modEffectiveDate-${rowIndex}`}>
                  {formatDate(subRow.modEffectiveDate)}
                </TableCell>
                <TableCell data-testid={`rateEffectiveDate-${rowIndex}`}>
                  {formatDate(subRow.rateEffectiveDate)}
                </TableCell>
                <TableCell data-testid={`experienceMod-${rowIndex}`}>
                  {subRow.experienceMod?.toFixed(2) ?? ''}
                </TableCell>
                <ClassCodeTableCell
                  classCode={subRow.classCode}
                  description={subRow.classDescription}
                  dataTestIdPrefix={`classCode-${rowIndex}`}
                />
                <TableCell data-testid={`exposureAmount-${rowIndex}`}>
                  {formatDollarAmount(subRow.exposureAmount)}
                </TableCell>
                <TableCell data-testid={`manualRate-${rowIndex}`}>
                  {subRow.manualRate?.toFixed(3)}
                </TableCell>
                <TableCell data-testid={`premiumAmount-${rowIndex}`}>
                  {formatDollarAmount(subRow.premiumAmount)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
